import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import {
  IsBoolean,
  IsEnum,
  IsInt,
  IsOptional,
  IsUUID,
  Min,
} from 'class-validator';
import { JobPhaseReadinessEnum } from '../enums/job-phase-readiness.enum';

/**
 * Body of POST /job-phase/:id/request-resource. Requests the resource for the
 * phase and, when a paint option was marked, records it on the job in the
 * same transaction (the admin used to PATCH job-phase then PATCH job).
 */
export class JobPhaseRequestResourceDto {
  @ApiPropertyOptional({ format: 'uuid', description: 'Direct assignment.' })
  @Expose()
  @IsOptional()
  @IsUUID('4')
  contractorId?: string;

  @ApiPropertyOptional({
    format: 'uuid',
    description: 'Suggestion that needs approval before assignment.',
  })
  @Expose()
  @IsOptional()
  @IsUUID('4')
  suggestedContractorId?: string;

  @ApiPropertyOptional({ type: 'integer', minimum: 0 })
  @Expose()
  @IsOptional()
  @IsInt()
  @Min(0)
  requestDelayDays?: number;

  @ApiPropertyOptional({ type: 'integer' })
  @Expose()
  @IsOptional()
  @IsInt()
  readyHour?: number;

  @ApiPropertyOptional({ enum: JobPhaseReadinessEnum })
  @Expose()
  @IsOptional()
  @IsEnum(JobPhaseReadinessEnum)
  readinessStatus?: JobPhaseReadinessEnum;

  @ApiPropertyOptional({ type: 'boolean' })
  @Expose()
  @IsOptional()
  @IsBoolean()
  trimOptionSelected?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    description:
      'Marks interior options finished in this phase. Only true is accepted; use Go Back to clear.',
  })
  @Expose()
  @IsOptional()
  @IsBoolean()
  interiorOptionsFinished?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    description:
      'Marks exterior options finished in this phase. Only true is accepted; use Go Back to clear.',
  })
  @Expose()
  @IsOptional()
  @IsBoolean()
  exteriorOptionsFinished?: boolean;
}
